import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faPen, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import {  useNavigate, useParams } from 'react-router-dom'
import { useGetFinalGradesQuery } from '../finalGradeApiSlice'
import { memo } from 'react'
import useAuth from "../../../hooks/useAuth"
import ReactQuill from 'react-quill';

const FinalGrade = ({ finalGrade, setShowModal, setCurrentFinalGrade, groupGrade, setCurrentGroupGrade, setShowUpdateModal }) => {
    const {groupId} = useParams()
    const { isTeacher, isAdmin, isStudent } = useAuth()



    const navigate = useNavigate()
  

    if (finalGrade) {
        //const created = new Date(finalGrade.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })
         const handleView = () => {
            setShowModal(true)
            setCurrentFinalGrade(finalGrade)
         }
         const handleEdit = () => {
            setCurrentGroupGrade(groupGrade)
            setShowUpdateModal(true)
         }
         const cellStatus = finalGrade.active ? '' : 'table__cell--inactive'

         const showButton = (
             <button
             className="icon-button  no-print table__button"
             onClick={handleView}
         >
             <FontAwesomeIcon icon={faEye} />
         </button>
         )
         const editButton = ((isAdmin || isTeacher)?
             <button
             className="icon-button  no-print table__button"
             onClick={handleEdit}
         >
             <FontAwesomeIcon icon={faPen} />
         </button> :<></>
         )
         
   
  
        return (
            <tr className="table__row">
                <td className={`table__cell finalGrade__title ${cellStatus}`}>{finalGrade.username}</td>
                <td className={`table__cell finalGrade__title ${cellStatus}`}>{finalGrade.fullname}</td>
                <td className={`table__cell finalGrade__title ${cellStatus}`}>{finalGrade.finalGradeBase?.courseName} <span className='small-text'>{finalGrade.finalGradeBase?.groupName}</span> </td>
                <td className={`table__cell finalGrade__dates ${cellStatus}`} >{finalGrade.finalGradeBase?.semester}  </td>
                <td className={`table__cell finalGrade_student finalGrade__done ${cellStatus}`} > {finalGrade.finalGradeBase?.year}</td>
                <td className={`table__cell finalGrade_student finalGrade__dates ${cellStatus}`} >{finalGrade.total?.toFixed(2)}  </td>
                <td className={`table__cell finalGrade_student finalGrade__dates ${cellStatus}`} >{groupGrade?.total} </td>
                <td className={`table__cell finalGrade_student finalGrade__dates ${cellStatus}`} ><span className='small-text'>({groupGrade?.updated?'manual':'auto'})</span></td>
                <td className={`table__cell ${cellStatus}`}>{showButton}{editButton}</td>
            </tr>
        )

    } else return null
}

const memoizedFinalGrade = memo(FinalGrade)

export default memoizedFinalGrade